import instanceQuery from 'graphql/queries/vat/VatSwitchQuery.graphql';

const VatSwitch = {
  type: 'VatSwitch',
  shortTitle: 'Switch VAT Scheme',
  title: 'Switch VAT Scheme',
  formTitle: 'Switch VAT Scheme',
  formUrl: '/Vat/SwitchScheme/',
  instance: instanceQuery,
  screenReference: 'VAT_SWITCH',
};

export default VatSwitch;
